

























import Vue from 'vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import SectionTitle from '@/components/atoms/SectionTitle.vue'
import MoreLink from '@/components/atoms/MoreLink.vue'
import InfomationItem from '@/components/molecules/InfomationItem.vue'
import SpecialItem from '@/components/molecules/SpecialItem.vue'
import SpecialItemUnit from '@/components/molecules/SpecialItemUnit.vue'
import StatusSection from '@/components/organisms/StatusSection.vue'

export default Vue.extend({
  name: 'LoggedInHome',
  components: {
    SimpleLoader,
    StatusSection,
    SectionTitle,
    MoreLink,
    SpecialItem,
    SpecialItemUnit,
    InfomationItem
  },
  computed: {
    isPageLoading(): boolean {
      return this.$state.home.isHomeLoading
    },
    profileName(): string {
      return this.$state.home.home.token ? this.$state.home.home.token.name : ''
    },
    profileOwnerName(): string {
      return this.$state.home.home.token ? `発行者：${this.$state.home.home.token.owner.name}` : ''
    },
    profileCover(): string {
      return this.$state.home.home.token ? this.$state.home.home.token.owner.profile_image.url : ''
    },
    profilePortrait(): string {
      return this.$state.home.home.token ? this.$state.home.home.token.profile_image.url : ''
    },
    profilePoint(): number {
      return this.$state.home.home.wallet ? this.$state.home.home.wallet.balances : 0
    },
    notices(): object[] {
      return this.$state.home.home.notices
    },
    benefits(): object[] {
      return this.$state.home.home.benefits
    },
    twitter(): boolean {
      return this.$state.home.home.twitter.connected
    }
  },
  mounted() {
    this.$store.dispatch('home/fetchHome')
  }
})
